import * as Diagram from "../../../../components/diagram";

export const ElderlyHealthCheckupList = {
  label: "長者健檢清單",
  key: "ElderlyHealthCheckupList",
  path: "ElderlyHealthCheckup/ElderlyHealthCheckupList",
  api: "TCS_V_OldStudyList01V",
  render: (options) => (
    <Diagram.ElderlyHealthCheckup.ElderlyHealthCheckupList {...options} />
  ),
  isRaw: true,
  isPage: true,
  columns: [
    {
      key: "Birthday",
      field: "Birthday",
      header: "Birthday",
    },
    {
      key: "Region",
      field: "Region",
      header: "Region",
    },
    {
      key: "StudyDate",
      field: "StudyDate",
      header: "StudyDate",
    },
    {
      key: "Item95",
      field: "Item95",
      header: "AFP\n甲型胎兒蛋白",
    },
    {
      key: "Item96",
      field: "Item96",
      header: "T4\n甲狀腺素",
    },
    {
      key: "Item97",
      field: "Item97",
      header: "TSH\n甲狀腺刺激素",
    },
    {
      key: "Item98",
      field: "Item98",
      header: "EKG\n心電圖檢查",
    },
    {
      key: "Item99",
      field: "Item99",
      header: "失智症篩檢(AD8)",
    },
    {
      key: "",
      field: "",
      header: "篩檢醫院",
    },
  ],
};
